import { CreateNewIcon, DeleteIcon, DuplicateIcon, EditIcon, ModifyPermissionsIcon, RenameIcon, SetAsDefaultIcon } from "../../components/action-menu/ActionMenuIcons";
import { ActionMenuItem } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";

export enum ConfigurationActionEnum {
    Edit = "edit",
    CreateNew = "createNew",
    Duplicate = "duplicate",
    SetAsDefault = "setAsDefault",
    ModifyPermissions = "modifyPermissions",
    Delete = "delete",
    Rename = "rename",
}

export type ConfigurationActions =
    ConfigurationActionEnum.Edit |
    ConfigurationActionEnum.CreateNew |
    ConfigurationActionEnum.Duplicate |
    ConfigurationActionEnum.SetAsDefault |
    ConfigurationActionEnum.ModifyPermissions |
    ConfigurationActionEnum.Delete |
    ConfigurationActionEnum.Rename;

export type ConfigurationActionItem = {
    action: ConfigurationActions
} & ActionMenuItem;

export const configurationActionItems: ConfigurationActionItem[] = [{
    id: 'create',
    label: i18n.t("actions.createNew"),
    action: ConfigurationActionEnum.CreateNew,
    icon: CreateNewIcon,
    order: 1,
    //dividerBefore: true,
}, {
    id: "edit",
    label: i18n.t("actions.edit"),
    icon: EditIcon,
    action: ConfigurationActionEnum.Edit,
    order: 2,
    dividerAfter: true
}, {
    id: 'permission',
    label: i18n.t("actions.modifyPermissions"),
    action: ConfigurationActionEnum.ModifyPermissions,
    icon: ModifyPermissionsIcon,
    order: 3
}, {
    id: 'defaults',
    label: i18n.t("actions.setAsDefault"),
    action: ConfigurationActionEnum.SetAsDefault,
    icon: SetAsDefaultIcon,
    order: 4
}, {
    id: 'duplicate',
    label: i18n.t("actions.duplicate"),
    action: ConfigurationActionEnum.Duplicate,
    icon: DuplicateIcon,
    order: 5,
    dividerAfter: true
}, {
    id: 'rename',
    label: i18n.t("actions.rename"),
    action: ConfigurationActionEnum.Rename,
    icon: RenameIcon,
    order: 6

}, {
    id: 'delete',
    label: i18n.t("actions.delete"),
    action: ConfigurationActionEnum.Delete,
    icon: DeleteIcon,
    order: 7
}];